import * as yup from 'yup';
import {
  ALPHA_NUMERIC_DASH_UNDERSCORE_ALLOW_SPACES_AT_START_END_PATTERN,
} from 'src/constants/validation';

export const schema = yup.object().shape({
  code: yup
    .string()
    .max(50, 'Site Code should not exceed 50 characters')
    .required('Site Code is required')
    .matches(
        ALPHA_NUMERIC_DASH_UNDERSCORE_ALLOW_SPACES_AT_START_END_PATTERN,
      'Site Code should contain only letters, digits and "-"'
    ),
  principalInvestigator: yup
    .string()
    .max(70, 'Principal Investigator should not exceed 70 characters')
    .required('Principal Investigator is required'),
  imagingFacilities: yup
    .array()
    .min(1)
    .required('Imaging Facilities is required'),
});
